import { useIntl } from 'react-intl';
import { formatCount } from '../UrgencySummary/urgencySummaryFormat';

export interface NewBornBarRow {
    key: string;
    label: string;
    count: number;
}

interface NewBornBarsProps {
    rows: NewBornBarRow[];
    /** Sobre qué se reparte: los nacidos vivos del período. */
    total: number;
    ariaLabelledBy: string;
}

/**
 * Un reparto como filas con barra y «X de N»: el nombre, una barra proporcional y la cantidad escrita (la barra es un adorno
 * de la cantidad). Las categorías en cero no se muestran. Sin ninguna con datos no dibuja nada.
 * TODO(design-system): gráficos. Novarium no define las barras horizontales.
 */
export default function NewBornBars({ rows, total, ariaLabelledBy }: NewBornBarsProps) {
    const intl = useIntl();
    const shown = rows.filter((row) => row.count > 0);
    if (shown.length === 0 || total <= 0) return null;
    return (
        <ul className="nv-newborn-bars" aria-labelledby={ariaLabelledBy}>
            {shown.map((row) => (
                <li key={row.key} className="nv-newborn-bar">
                    <span className="nv-newborn-bar__name">{row.label}</span>
                    <span className="nv-newborn-bar__track" aria-hidden="true">
                        <span className="nv-newborn-bar__fill" style={{ width: `${Math.min(row.count / total, 1) * 100}%` }} />
                    </span>
                    <span className="nv-newborn-bar__value">
                        {intl.formatMessage({ id: 'NewBornKpiOf' }, { count: formatCount(intl, row.count), total: formatCount(intl, total) })}
                    </span>
                </li>
            ))}
        </ul>
    );
}
